// Подгонка <title> под лимит: layout добавляет суффикс « - Central Trans» (16 симв.),
// поэтому в page-level title оставляем место под него.
export const TITLE_SUFFIX = ' - Central Trans';

// Служебные слова, которые нельзя оставлять в конце обрезанного заголовка
const TRAILING_WORDS = /\s+(в|во|из|на|по|до|для|с|со|от|к|ко|о|об|при|без|это|и|а|но|или|как|что|чем)\s*$/i;

const normalize = (text) => String(text || '').replace(/\s+/g, ' ').trim();

/**
 * Обрезает текст по границе слова, убирая хвостовые предлоги/союзы и пунктуацию.
 *
 * @param {string} text
 * @param {number} max
 * @returns {string}
 */
export function fitSeoTitle(text, max) {
  const value = normalize(text);

  if (!value) {
    return '';
  }
  if (value.length <= max) {
    return value;
  }

  const cut = value.slice(0, max);
  const space = cut.lastIndexOf(' ');
  let trimmed = (space > 15 ? cut.slice(0, space) : cut)
    .replace(/[\s,.;:–—-]+$/g, '')
    .trim();

  // «…из Бронниц в» → «…из Бронниц»
  for (let i = 0; i < 2; i += 1) {
    trimmed = trimmed.replace(TRAILING_WORDS, '').replace(/[\s,.;:–—-]+$/g, '').trim();
  }

  return trimmed || value.slice(0, max).trim();
}

/**
 * Выбирает первый вариант заголовка, который влезает в лимит с учётом суффикса.
 * Если ни один не влезает — обрезает первый по границе слова.
 *
 * @param {Array<string|undefined|null>} candidates
 * @param {number} maxTotal максимальная итоговая длина <title> с суффиксом
 * @returns {string}
 */
export function pickSeoTitle(candidates, maxTotal) {
  const limit = Math.max(10, Number(maxTotal || 70) - TITLE_SUFFIX.length);
  const values = (candidates || []).map(normalize).filter(Boolean);

  const fitting = values.find((value) => value.length <= limit);
  if (fitting) {
    return fitting;
  }

  return fitSeoTitle(values[0] || '', limit);
}
